<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
        
        
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary header_new">
            <div class="d-flex align-items-center">
         
               <span @click="goBack()" class="text-white"> <i class="bi bi-arrow-left-circle-fill"></i></span> &nbsp; &nbsp;
                  
                  <span>
                     <h5 class="text-white">{{language?.attendance_report ?? "Attendance Report"}}  {{class_name[0]?.name}}</h5>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#branch"
                  aria-controls="branch">
                        <b class="bg-white   rounded-circle user-icon">
                 <i class="bi bi-filter  d-flex m-1 h4 text-dark"></i>
                  </b>
                  </a>
               </div>
            </div>
            



         </div>
    
         <!-- body -->
        <div class="my-auto overflow-auto vh-100">
  <!-- Attendance Record -->

   <div class="mt-1">

    <h6>{{filter_string}}</h6>

    </div>

    <div class="row">
      <div class="">
        <!-- Attendance Table -->
        <div class="card mt-2" v-if="attendancereport?.length > 0">
          <div class="card-body p-0">
            <table class="table table-striped table-hover m-0">
              <thead class="table-dark">
                <tr>
                    <th class="fixed_roll">SR</th>
                    <th class="fixed_name">Name</th>
                    <th v-for="date in dates" :key="date" :colspan="getSessionCount(date)" class="font-sm">
                        {{ formatDate(date) }}
                    </th>
                    <th v-if="dates && dates.length > 0">Present</th>
                    <th v-if="dates && dates.length > 0">Absent</th>
                </tr>
                <tr>
                    <th class="fixed_roll"></th>
                    <th class="fixed_name"></th>
                    <template v-for="date in dates" :key="'sub-' + date">
                        <template v-if="getSessionCount(date) > 0">
                            <th v-for="session in getSessionsForDate(date)" :key="session" class="session-header font-sm">
                                {{ formatSession(session) }}
                            </th>
                        </template>
                        <template v-else> 
                            <th class="session-header"></th>
                        </template>
                    </template>
                    <th v-if="dates && dates.length > 0"></th>
                    <th v-if="dates && dates.length > 0"></th>
                </tr>
            </thead>
                <tbody>
                    <tr v-for="(student, i) in attendancereport" :key="i">
                        <td class="fixed_roll">{{ i+1 }}</td>
                        <td class="fixed_name">{{ getInitials(student.name) }}</td>
                        
                        <!-- Date columns with session sub-columns -->
                        <template v-for="date in dates" :key="'date-' + date">
                            <template v-if="hasSessionsForDate(date)">
                                <td v-for="session in getSessionsForDate(date)" :key="session" class="session-cell">
                                    <span class="session-mark" :class="getSessionClass(student, date, session)">
                                        {{ getSessionMark(student, date, session) }}
                                    </span>
                                </td>
                            </template>
                            <template v-else>
                                <!-- Show empty cell with — when no sessions exist for this date -->
                                <td class="session-cell">
                                    <span class="session-mark text-muted">—</span>
                                </td>
                            </template>
                        </template>
                        
                        <td class="text-success">{{ student.present_count || 0 }}</td>
                        <td class="text-danger">{{ student.absent_count || 0 }}</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>

        <!-- No Record Found -->
        <div class="text-center" v-else>
          <span class="text-danger">No Record Found.</span>
        </div>
      </div>
    </div>
  </div>






            <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="branch"
      aria-labelledby="orderLabel">
      <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3 header_new">
        <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
            class="bi bi-arrow-left fs-5 text-white"></i></a>
        <h6 class="offcanvas-title text-white m-0" id="orderLabel">Filter</h6>
      </div>
      <div class="offcanvas-body">
          <div class="col-12 row">
            <div class="col-12 row">
             <!-- <div class="col-6">-->
             <!-- <label>Name</label>-->
             <!-- <select class="form-select form-select-sm" id="customers" ref="customers" v-model="filter.studentid">-->
                <!-- <option value="0" disabled="" selected="">{{language?.select_cutomer}}</option> -->
              
             <!--<option v-for="(item, index) in studentlist" :key="index" :value="item.id">{{ item.name }}</option> -->
             <!-- </select>-->
             
             <!-- </div>-->

              <div class="col-6">
              <label>Exam</label>
              <select class="form-select " id="room_no" ref="room_no" v-model="filter.id">
                
              <option v-for="(item, index) in class_name" :key="index" :value="item.id">{{ item.name }}</option>
              </select>
            
              </div>
            <div class="col-6 ">
                    <label for="status" class="form-label m-0 ">Status</label>
                        <select id="status" v-model="filter.mark" class="form-control m-0 ">
                           <option value="1">Present</option>
                           <option value="0">Absent</option>
                        </select>
                  </div>

              </div>

              <div class="col-6 mt-2">
                  <label for="address m-0 p-0" class="form-label">From Date</label>
                  <input type="date" id="" v-model="filter.fromdate" class="form-control m-0" >
                
              </div>
              <div class="col-6 mt-2">
                  <label for="address m-0" class="form-label">To date</label>
                  <input type="date" id="" v-model="filter.todate" class="form-control m-0" >    
              </div>

              



              <div class="offcanvas-footer">
                <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
                <button class="btn btn-success col-12 newbtn"  @click="filter_attendance_record">
                 <i class="bi bi-check"></i> &nbsp;Filter
               </button>
            </div>
  </div>
  </div>
          
    
    </div>





















         
    
      </div>
    </div>
</template>

<style scoped>

.table-wrapper {
  overflow-x: auto;
  position: relative;
  max-width: 100%; /* limit width */
}

.table th, .table td { 
}
 .fixed_name {
  position: sticky;
  left: 40px;  
  z-index: 2;
}

.fixed_name {
  left: 40px; /* adjust based on Roll column width */
}


table{
    font-size: 14px;
}
td{
    background: white;
}
.header_new {
    border-radius: 0px 0px 20px 20px;
    background: linear-gradient(135deg, #c29300 0%, #fc0000 100%);
}
.user-icon {
    height: 35px;
    width: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
    padding-left: 1px;
}
.session-header {
    font-size: 11px;
    line-height: 1.2;
    white-space: pre-line;
    text-align: center;
    padding: 2px;
        font-weight: 400;
}

.session-mark {
    display: inline-block;
    margin: 0 2px;
    font-weight: bold;
}

.fixed_roll {
    position: sticky;
    left: 0; 
    z-index: 2;
}

.table th, .table td {
    vertical-align: middle;
    text-align: center;
}
.br{
    border-right: 1px solid orange;
}
 

.session-cell {
    padding: 4px !important;
    min-width: 40px;
    text-align: center;
}

.session-mark {
    display: block;
    font-weight: bold;
    font-size: 14px;
}
 

.table th, .table td {
    vertical-align: middle;
    border: 1px solid #dee2e6;
}

.br {
    border-right: 2px solid #000 !important;
}
.font-sm{
    font-size: smaller;
}
</style>
  
<script> 
import axios from "@/plugins/stdaxios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
   //  this.getStdAttendance(); // Call the method here
   if(this.$route.query.id){
   this.getStdAttendance(this.$route.query.id);
    this.filter.studentid=this.$route.query.id;
   }else{
     this.getStdAttendance();

   } 
    
},
  data() {
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      language: this.getLocalStorageArray('lang'),
      roomcat:{
         name:'',
      },
      attendancereport:[], 
      dates:[],
      date_sessions:[],
      branch_name:'',
         filter:{
          id:0,
          fromdate:new Date().toISOString().split('T')[0],
          todate:new Date().toISOString().split('T')[0],
          studentid:'',
          mark:1,
        },
        studentlist:[],
        class_name:[],
        filter_string:'',
        class_row:[]

    }
  },
  methods:{
      getSessionCount(date) {
        const sessions = this.getSessionsForDate(date);
        // Always return at least 1 to maintain table structure
        return Math.max(sessions.length, 0);
    },
    
   getSessionsForDate(date) {
        // Check if any student has sessions for this date
        if (!this.attendancereport || this.attendancereport.length === 0) return [];
        
        const hasSessions = this.attendancereport.some(student => 
            student.dates && 
            student.dates[date] && 
            student.dates[date].sessions && 
            Object.keys(student.dates[date].sessions).length > 0
        );
        
        if (!hasSessions) return [];
        
        // Get sessions from the first student that has them
        const studentWithSessions = this.attendancereport.find(student => 
            student.dates && 
            student.dates[date] && 
            student.dates[date].sessions
        );
        
        return studentWithSessions ? Object.keys(studentWithSessions.dates[date].sessions) : [];
    },
    

    
    hasSessionsForDate(date) {
        const sessions = this.getSessionsForDate(date);
        return sessions && sessions.length > 0;
    },
    
    formatSession(session) {
        // session is in format "HH:MM-Staff Name"
        const parts = session.split('-');
        return parts[0] + (parts[1] ? '\n' + parts.slice(1).join(' ') : '');
    },
    
    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            weekday: 'short', 
            month: 'short', 
            day: 'numeric' 
        });
    },
    
    getInitials(name) {
        if (!name) return '';
        const parts = name.trim().split(' ');
        if (parts.length === 1) return parts[0];
        return `${parts[0]} ${parts[parts.length - 1]}`;
    },
    
    getSessionClass(student, date, session) {
        const mark = this.getSessionMarkValue(student, date, session);
        return {
            'text-success': mark === '1',
            'text-danger': mark === '0',
            'text-muted': mark === null || mark === undefined
        };
    },
    
    getSessionMark(student, date, session) {
        const mark = this.getSessionMarkValue(student, date, session);
        if (mark === '1') return '✓';
        if (mark === '0') return '✗';
        return '—';
    },
    
    getSessionMarkValue(student, date, session) {
        // Safely access nested properties
        if (!student.dates || !student.dates[date] || !student.dates[date].sessions) {
            return null;
        }
        return student.dates[date].sessions[session];
    },
    initializeHomeContent(){
    

    },
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 
  
    async getStdAttendance(id) {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("get_student_attendancereport",{id:id}).then((response) => {
               self.attendancereport=response.data.report;
               self.date_sessions=response.data.date_sessions;
               self.dates=response.data.dates;
               self.class_name=response.data.class_name;

              
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

            
        getLocalStorageArray(key) {
                let data = localStorage?.getItem(key);
                try {
                    return data ? JSON.parse(data) : [];
                } catch (e) {
                    console.error("Error parsing localStorage data", e);
                    return [];
                }
            },


                    filter_attendance_record() {
                            this.loading = true;
                            this.error = null;
                    
                            try {
                            var self=this;
                                axios.post("get_student_attendancereport",self.filter).then((response) => {
                         
                                self.attendancereport=response.data.report;
                                self.date_sessions=response.data.date_sessions;
                                self.dates=response.data.dates;
                                self.class_name=response.data.class_name;

                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
    
                            
                            }).then(() => {
                                self.initializeHomeContent();
                            }).catch((err) => {
                                
                            });;
                            

                            } catch (err) {
                            this.error = err.response?.data?.message || "Login failed. Please try again.";
                            } finally {
                            this.loading = false;
                            }
                        },



















  }
}






</script>
